import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { CheckCircle, Mail, Download, Home } from 'lucide-react';

const OrderConfirmation = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
          </div>
          
          <h1 className="text-4xl font-bold text-black mb-4">Order Confirmed!</h1>
          <p className="text-xl text-gray-600 mb-8">
            Your gift card has been successfully purchased and will be delivered as scheduled.
          </p>

          <div className="bg-[#E3F2FD] rounded-lg p-8 mb-8">
            <p className="text-sm text-gray-600 mb-2">Order ID</p>
            <p className="text-xl font-mono font-bold text-[#1E88E5] mb-6">{orderId}</p>
            
            <div className="grid md:grid-cols-2 gap-6 text-left">
              <div className="bg-white rounded-lg p-4">
                <div className="flex items-start space-x-3">
                  <Mail className="w-6 h-6 text-[#1E88E5] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-black mb-1">Email Delivery</h3>
                    <p className="text-sm text-gray-600">
                      The recipient will receive the gift card via email on the scheduled date with a unique redemption code.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg p-4">
                <div className="flex items-start space-x-3">
                  <Download className="w-6 h-6 text-[#1E88E5] flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-black mb-1">Confirmation Sent</h3>
                    <p className="text-sm text-gray-600">
                      A copy of the order confirmation has been sent to your email address.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-6 mb-8">
            <h2 className="text-xl font-semibold text-black mb-3">How to Redeem</h2>
            <ol className="text-left space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="font-bold text-[#1E88E5] mr-2">1.</span>
                <span>Recipient receives the gift card email with a unique coupon code</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-[#1E88E5] mr-2">2.</span>
                <span>They visit MethodMate subscription page</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-[#1E88E5] mr-2">3.</span>
                <span>Enter the coupon code when subscribing</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-[#1E88E5] mr-2">4.</span>
                <span>Press "Apply" to get 100% discount</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-[#1E88E5] mr-2">5.</span>
                <span>Complete signup and enjoy free subscription!</span>
              </li>
            </ol>
            <p className="text-sm text-red-600 font-semibold mt-4">
              ⚠️ Note: Coupon codes can only be used once
            </p>
          </div>

          <button
            onClick={() => navigate('/')}
            className="px-8 py-4 bg-[#1E88E5] text-white text-lg font-semibold rounded-lg hover:bg-[#1565C0] transition-all transform hover:scale-105 shadow-lg inline-flex items-center space-x-2"
            data-testid="return-home-btn"
          >
            <Home className="w-5 h-5" />
            <span>Return to Home</span>
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OrderConfirmation;
